// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type CreateMasterInvoiceResponseFragment = { __typename?: 'CreateMasterInvoiceResponseDTO', invoiceId: number, bolloRequired: boolean };

export const CreateMasterInvoiceResponseFragment = gql`
    fragment CreateMasterInvoiceResponse on CreateMasterInvoiceResponseDTO {
  invoiceId
  bolloRequired
}
    `;
/* eslint-enable */